import { FiAlertTriangle, FiCheckCircle, FiEdit2, FiSearch } from 'react-icons/fi';
import Button from '../../components/ui/Button';
import Badge from '../../components/ui/Badge';
import MobileMenuButton from '../../components/ui/MobileMenuButton';
import CloseButton from '../../components/ui/CloseButton';
import AddAssetButton from '../../components/ui/AddAssetButton';
import BackButton from '../../components/ui/BackButton';
import { Category, Section, Row } from './galleryPrimitives';

/** Actions — buttons, icon buttons, hero CTAs, and dense real-app button markup. */
export default function ActionsGallery() {
  return (
    <Category id="actions" title="Actions">
      <Section name="Button" file="components/ui/Button.jsx">
        <Row label="variant">
          <Button variant="primary">Primary</Button>
          <Button variant="outline">Outline</Button>
          <Button variant="ghost">Ghost</Button>
          <Button variant="secondary">Secondary</Button>
          <Button variant="danger">Danger</Button>
        </Row>
        <Row label="size=&quot;sm&quot;">
          <Button variant="primary" size="sm">Primary</Button>
          <Button variant="outline" size="sm">Outline</Button>
          <Button variant="ghost" size="sm">Ghost</Button>
          <Button variant="secondary" size="sm">Secondary</Button>
          <Button variant="danger" size="sm">Danger</Button>
        </Row>
        <Row label="disabled">
          <Button variant="primary" disabled>Primary</Button>
          <Button variant="outline" disabled>Outline</Button>
          <Button variant="ghost" disabled>Ghost</Button>
          <Button variant="secondary" disabled>Secondary</Button>
          <Button variant="danger" disabled>Danger</Button>
        </Row>
        <Row label="with icon">
          <Button variant="primary"><FiCheckCircle /> Save</Button>
          <Button variant="ghost"><FiSearch /> Search</Button>
        </Row>
      </Section>

      <Section name="MobileMenuButton" file="components/ui/MobileMenuButton.jsx">
        <Row label="default">
          <MobileMenuButton onClick={() => {}} />
        </Row>
        <Row label="disabled">
          <MobileMenuButton onClick={() => {}} disabled />
        </Row>
        <Row label="on dark bg">
          <div style={{ background: 'var(--sidebar-bg)', padding: '1rem', borderRadius: 8, display: 'inline-flex' }}>
            <MobileMenuButton onClick={() => {}} />
          </div>
        </Row>
        <Row label="badge (ring colour assumes a dark surface)">
          <div style={{ background: 'var(--sidebar-bg)', padding: '1rem', borderRadius: 8, display: 'inline-flex', gap: '1rem' }}>
            <MobileMenuButton onClick={() => {}} badge />
            <MobileMenuButton onClick={() => {}} />
          </div>
        </Row>
      </Section>

      <Section name="CloseButton" file="components/ui/CloseButton.jsx">
        <Row label="default">
          <CloseButton onClick={() => {}} />
        </Row>
        <Row label="disabled">
          <CloseButton onClick={() => {}} disabled />
        </Row>
        <Row label="on surface">
          <div style={{ background: 'var(--bg-surface)', padding: '1rem', borderRadius: 8, display: 'inline-flex', gap: '0.5rem', alignItems: 'center' }}>
            <span style={{ fontSize: 'var(--text-sm)', color: 'var(--text-secondary)' }}>Modal title</span>
            <CloseButton onClick={() => {}} />
          </div>
        </Row>
      </Section>

      <Section name="AddAssetButton" file="components/ui/AddAssetButton.jsx">
        <Row label="with group">
          <AddAssetButton groupLabel="DB.1" onClick={() => {}} />
        </Row>
        <Row label="no group">
          <AddAssetButton onClick={() => {}} />
        </Row>
        <Row label="disabled">
          <AddAssetButton groupLabel="DB.1" onClick={() => {}} disabled />
        </Row>
      </Section>

      <Section name="BackButton" file="components/ui/BackButton.jsx">
        <Row label="on dark bg">
          <div style={{ background: 'var(--sidebar-bg)', padding: '1rem', borderRadius: 8, display: 'inline-flex', gap: '0.5rem', alignItems: 'center' }}>
            <BackButton onClick={() => {}} />
          </div>
        </Row>
        <Row label="on surface">
          <BackButton onClick={() => {}} />
        </Row>
        <Row label="disabled">
          <BackButton onClick={() => {}} disabled />
        </Row>
      </Section>

      <Section name="Hero CTAs (keep the full gold treatment)" file=".btn.login-cta · .btn-start-job">
        <div style={{ display: 'grid', gap: '1rem', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))' }}>
          <button type="button" className="btn btn-primary login-cta">Sign In</button>
          <button type="button" className="btn btn-primary btn-start-job">Start Job</button>
        </div>
      </Section>

      <Section name="Dense contexts (real app markup)" file="asset-card-actions · team-table-actions · dashboard-site-action-btn">
        <Row label="asset card (untested)">
          <div className="asset-card-actions" style={{ display: 'flex', gap: '0.5rem' }}>
            <button type="button" className="btn btn-sm btn-success">Pass</button>
            <button type="button" className="btn btn-sm btn-danger">Fail</button>
          </div>
        </Row>
        <Row label="asset card (tested)">
          <div className="asset-card-actions" style={{ display: 'flex', gap: '0.5rem', alignItems: 'center' }}>
            <Badge variant="success">Passed</Badge>
            <Badge variant="warning">Saving…</Badge>
            <button type="button" className="btn btn-sm btn-icon" aria-label="Edit result">
              <FiEdit2 size={16} />
            </button>
          </div>
        </Row>
        <Row label="team table row">
          <div className="team-table-actions" style={{ display: 'flex', gap: '0.5rem' }}>
            <Button variant="secondary" size="sm" aria-label="Edit"><FiEdit2 /></Button>
            <Button variant="secondary" size="sm" aria-label="Reset"><FiSearch /></Button>
            <Button variant="danger" size="sm" aria-label="Remove"><FiAlertTriangle /></Button>
          </div>
        </Row>
        <Row label="dashboard repair row">
          <div style={{ display: 'flex', gap: '0.5rem' }}>
            <a className="btn btn-sm dashboard-site-action-btn" href="#top">View Site</a>
            <Button variant="outline" size="sm" className="dashboard-site-action-btn">Repair Visit</Button>
          </div>
        </Row>
      </Section>
    </Category>
  );
}
